import { ChartSparkline } from '../../Chart'
import { BIRDVIEW_CHART_DATE_KEY } from '../DashboardBirdview.constants.charts'

import { BIRDVIEW_SPARKLINE_TOOLTIP_PROPS } from './BirdviewSparkline.constants'
import { getBirdviewSparklineColor } from './BirdviewSparkline.utils'
import { BirdviewSparklineTooltip } from './BirdviewSparklineTooltip'

function BirdviewSparkline({ points, tone, unit }) {
  return (
    <ChartSparkline
      color={getBirdviewSparklineColor(tone)}
      data={points}
      nameKey={BIRDVIEW_CHART_DATE_KEY}
      tooltipProps={{
        ...BIRDVIEW_SPARKLINE_TOOLTIP_PROPS,
        content: <BirdviewSparklineTooltip unit={unit} />,
      }}
    />
  )
}

export default BirdviewSparkline
